import ImageCropperContainer from "../../Componant/BonusUI/ImageCropper";

const ImageCropper = () => {
  return (
    <div className="page-body">
      <ImageCropperContainer />
    </div>
  );
};

export default ImageCropper;
